import { EDITOR_TYPE } from '@/utils/constants';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('dashboard', [
      'users',
      'isFirstEditor',
    ]),
    ...mapState('user', [
      'user',
    ]),
  },
  methods: {
    ...mapActions('dashboard', [
      'updateUserOnboardingStatus',
    ]),
    getEditorType() {
      return this.isFirstEditor ? EDITOR_TYPE.FIRST : EDITOR_TYPE.SECOND;
    },
    getActiveUser() {
      return this.users.find(user => user.email === this.user.email);
    },
    updateUserOnboarding(status) {
      this.getActiveUser().onboardingStatus = status;
      this.updateUserOnboardingStatus(this.users);
    },
  },
};
